<script>
export const group = 'Bottom'
</script>

<script setup>
import TwoLineLowerThird from '../kijk_live_qmusic_nl_default/shared/TwoLineLowerThird.vue'
import MysterySoundBoom from '../../../assets/images/mystery_sound_boom.png'
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Object,
})

const amount = computed(() => props.item.enrichment?.amount?.toLocaleString('nl-NL'))

const boom = ref(null)

const timelineLowerThird = ref(null)
const timelineLowerThirdOut = ref(null)
const timeline = ref(null)

onMounted(() => {
  timeline.value = gsapTimeline({ name: 'MysterySoundAmountSmall' })
    .startInvisible(boom)
    .set(boom, { transformOrigin: 'bottom center' })
    .from(boom, { transform: 'rotate(-125deg)' }, '<')
    .to(boom, { transform: 'rotate(-45deg)', duration: 0.8, ease: 'expo.out' }, '<0.1')
    .add(timelineLowerThird, '<')
    .to(
      boom.value,
      {
        rotation: -40,
        duration: 5,
        yoyo: true,
        repeat: -1,
        ease: 'power1.inOut',
        keyframes: [{ rotation: -50 }],
      },
      '>'
    )
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timeline.value?.kill()

  await gsapTimeline({ name: 'MysterySoundAmountSmall - End' }).add(timelineLowerThirdOut.value()).to(boom, { transform: 'rotate(-125deg)', duration: 0.6, ease: 'expo.in' }, '<').endInvisible(boom)
})
</script>

<template>
  <TwoLineLowerThird title="Het geluid" :line="`is nu €${amount} waard`" @timeline="timelineLowerThird = $event" @timelineOut="timelineLowerThirdOut = $event" />
  <img ref="boom" :src="MysterySoundBoom" class="absolute w-60 bottom-[-20px] -space-y-3 left-[900px] rotate-[-125deg]" />
</template>
